import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const LoginAPI = createApi({
  reducerPath: "LoginAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: BaseUrl,
    prepareHeaders: (headers) => {
      headers.set("Accept", "application/json");
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    submitLoginForm: builder.mutation({
      query: (formData) => ({
        url: "admin/login",
        method: "POST",
        body: formData,
      }),
    }),
    editAdminProfile: builder.mutation({
      query: (formData) => ({
        url: "admin/profile-update",
        method: "PATCH",
        body: formData,
      }),
    }),
    getAdminProfile: builder.query({
      query: () => `admin/me`,
    }),
    submitForgotPassword: builder.mutation({
      query: (formData) => ({
        url: "admin-forgot-password",
        method: "POST",
        body: formData,
      }),
    }),
    sendOTP: builder.mutation({
      query: (formData) => ({
        url: "admin-verify-otp",
        method: "POST",
        body: formData,
      }),
    }),
    resetPassword: builder.mutation({
      query: (formData) => ({
        url: "admin-reset-password",
        method: "POST",
        body: formData,
      }),
    }),
  }),
});

export const { useSubmitLoginFormMutation, useEditAdminProfileMutation, useGetAdminProfileQuery, useSubmitForgotPasswordMutation, useSendOTPMutation, useResetPasswordMutation} =
  LoginAPI;
